<h3 mat-dialog-title>
   <ng-container *ngIf="canEdit$ | async">
      {{ editAction }}
   </ng-container>
   Business Unit
   <ng-container *ngIf="!(canEdit$ | async)">Details</ng-container>
</h3>

<form [formGroup]="form" (ngSubmit)="save()">
   <mat-dialog-content>
      <mat-form-field>
         <input
            [readonly]="!(canEdit$ | async)"
            appAutoFocus
            matInput
            type="text"
            placeholder="Name"
            formControlName="name"
            required
         />
      </mat-form-field>
      <app-team-member-autocomplete
         [canEdit]="canEdit$ | async"
         placeholder="Director"
         [idFormControl]="getControl('directorId')"
         (optionSelected)="setDirectorId($event)"
      ></app-team-member-autocomplete>
      <!-- <mat-form-field>
      <textarea
        [readonly]="!(canEdit$ | async)"
        cdkTextareaAutosize
        matInput
        type="text"
        placeholder="Purpose"
        formControlName="purpose"
      ></textarea>
    </mat-form-field> -->
      <div class="description">
         <mat-form-field class="fill-height">
            <mat-label *ngIf="form.value.purpose">Purpose</mat-label>
            <textarea
               class="editor"
               matInput
               type="text"
               formControlName="purpose"
               [froalaEditor]="editorConfig"
            ></textarea>
         </mat-form-field>
      </div>
   </mat-dialog-content>
   <mat-dialog-actions>
      <div class="button-container">
         <button
            type="submit"
            mat-raised-button
            color="primary"
            *ngIf="canEdit$ | async"
            [disabled]="form.pristine || !form.valid"
         >
            Save
         </button>
         <button type="button" mat-raised-button (click)="cancel()">
            <span *ngIf="canEdit$ | async; else noEdit">Cancel</span>
            <ng-template #noEdit>Close</ng-template>
         </button>
      </div>
   </mat-dialog-actions>
</form>
